// extracted by mini-css-extract-plugin
export default {"wrap":"wrap__ODTIJ","panel":"panel__FS08U","resizing":"resizing__WGKUW","panel__resizer":"panel__resizer__UMkZi","panel__content":"panel__content__QoYKC"};